<div class="mobile-header" [style.background-color]="dialogHeader ? 'var(--inputbox-primary)' : 'var(--general-body-primary)'" >
  <i class="icon-chevron-left left" (click)="backWithLocation()" *ngIf="isShowBackButton"></i>
  <h1 class="title" *ngIf="title">{{ title | translate}}</h1>
</div>
